import classNames from "classnames";

import {
  roundAndDropTrailingZeros,
  translate,
  useWindowDimensions,
} from "@ascendnow/shared";

import styles from "./AscTopStudentList.module.scss";
import AscTableResponsive from "../AscTableResponsive/AscTableResponsive";
import AscRankSign from "../AscRankSign/AscRankSign";

interface ITopStudentData {
  groupRank: number;
  name: string;
  timeOnPlatform: string;
  completion: number;
  grade: number;
  schoolRank: number;
  globalRank: number;
}

export interface AscTopStudentListProps {
  className?: string;
  data: ITopStudentData[];
}

export default function AscTopStudentList({
  className,
  data,
}: AscTopStudentListProps) {
  const { width } = useWindowDimensions();
  return (
    <div
      data-testid="asc-top-student-list"
      className={classNames(styles.ground, className)}
    >
      <AscTableResponsive<ITopStudentData>
        title={translate("topStudentsTitle")}
        rowKey="groupRank"
        data={data}
        className={styles.table}
        titleClassName={styles.tableTitle}
        columnHeaderClassName={styles.tableHeaderColumn}
        columnBodyClassName={styles.tableBodyColumn}
        columns={[
          {
            title: translate("groupRank"),
            dataIndex: "groupRank",
            render: (el) => (
              <AscRankSign
                rank={el as number}
                size="small"
                className={styles.tableRank}
              />
            ),
            sort: {
              exist: false,
            },
            width: 100 + (width > 2100 ? 50 : 0),
            align: "center",
          },
          {
            title: translate("studentName"),
            dataIndex: "name",
            render: (el) => <span>{el as string}</span>,
            sort: {
              exist: false,
            },
            className: styles.tableNameColumn,
          },
          {
            title: translate("timeOnPlatform"),
            dataIndex: "timeOnPlatform",
            render: (el) => <span>{el as string}</span>,
            sort: {
              exist: false,
            },
            width: 120 + (width > 2100 ? 50 : 0),
            align: "center",
          },
          {
            title: translate("completion"),
            dataIndex: "completion",
            render: (el) => (
              <span>{roundAndDropTrailingZeros(el as number)}%</span>
            ),
            sort: {
              exist: false,
            },
            width: 100 + (width > 2100 ? 50 : 0),
            align: "center",
          },
          {
            title: translate("grade"),
            dataIndex: "grade",
            render: (el) => (
              <span>{roundAndDropTrailingZeros(el as number)}%</span>
            ),
            sort: {
              exist: false,
            },
            width: 80 + (width > 2100 ? 50 : 0),
            align: "center",
          },
          {
            title: translate("schoolRank"),
            dataIndex: "schoolRank",
            render: (el) => <span>{el as number}</span>,
            sort: {
              exist: false,
            },
            width: 100 + (width > 2100 ? 50 : 0),
            align: "center",
          },
          {
            title: translate("globalRank"),
            dataIndex: "globalRank",
            render: (el) => <span>{el as number}</span>,
            sort: {
              exist: false,
            },
            width: 100 + (width > 2100 ? 50 : 0),
            align: "center",
          },
        ]}
      />
    </div>
  );
}
